module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allRecipes":"All recipes"},"de":{"allRecipes":"Alle Rezepte"}}')
  delete Component.options._Ctor
}
